import {debug} from 'loglevel'

function detect_product_theme() {
  const host_ = location.host.split(':')[0]
  const parts_ = host_.split('.')
  // const pre_ = parts_[0]
  const pre_ = parts_[0].slice(0, 3)
  const tail_ = parts_[parts_.length-1]
  const test = (host_ == '10.25.1.25') || (tail_ == 'test')
  // es 全庫(九庫), p 單庫,
  const theme = ['npm', 'soc', 'sin', 'tcm', 'bio', 'mdn', 'cbs', 'tai', 'syu', 'art', 'waa', 'lio'].includes(pre_) ? 'p' : 'es'
  // 九庫:undefined, 單庫: soc / sin / bio / mdn / cbs / tai / syu / art / waa
  const mainset_id = (theme == 'es') ? undefined : (pre_ == 'lio') ? 'art' : pre_
  debug('host', location.host, pre_, theme, mainset_id)

  const mainset_ = toc_options.find((i)=>(i.id == mainset_id) || (i.id == `${mainset_id}_mainset`))
  const mainset_name = mainset_ ? mainset_.name : undefined
  const theme_name = theme == 'es' ? '臺灣學術經典' : mainset_name

  return {theme, theme_name, mainset_id, mainset_name, test}
}

function require_toc_options() {
  let toc_options, jinfo
  "#if process.env.BUILD_ENV == 'tw'"
  toc_options = require("@/../sdata/toc_tw.json")
  jinfo = require("@/../sdata/jinfo.json")
  "#elif process.env.BUILD_ENV == 'cn'"
  toc_options = require("@/../sdata/toc_cn.json")
  jinfo = require("@/../sdata/jinfo_cn.json")
  "#elif process.env.BUILD_ENV == 'ntut'"
  toc_options = require("@/../sdata/toc_95j.json")
  jinfo = require("@/../sdata/jinfo.json")
  "#else"
  toc_options = require("@/../sdata/toc.json")
  jinfo = require("@/../sdata/jinfo.json")
  "#endif"
  return {toc_options, jinfo}
}
const {toc_options, jinfo} = require_toc_options()

function site_settings() {
  let site_override, rr
  "#if process.env.BUILD_ENV == 'nlpi'"
  site_override = require("@/../conf/nlpi.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'ntut'"
  site_override = require("@/../conf/ntut.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'soc'"
  site_override = require("@/../conf/soc.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'sin'"
  site_override = require("@/../conf/sin.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'bio'"
  site_override = require("@/../conf/bio.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'mdn'"
  site_override = require("@/../conf/mdn.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'cbs'"
  site_override = require("@/../conf/cbs.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'tai'"
  site_override = require("@/../conf/tai.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'syu'"
  site_override = require("@/../conf/syu.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'art'"
  site_override = require("@/../conf/art.json")
  rr = site_override.theme
  "#elif process.env.BUILD_ENV == 'waa'"
  site_override = require("@/../conf/waa.json")
  rr = site_override.theme
  "#else"
  rr = detect_product_theme()
  "#endif"
  // debug('rr from detect_product_theme()', rr)
  console.log('rr from detect_product_theme()', rr)
  return rr
}

export {
  toc_options,
  jinfo,
  site_settings,
}
